import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, pipe, throwError } from 'rxjs';

import { GenericService } from '@app/core/services/generic.service';

import { Servidor, LoginUsuario, Loading } from '@app/shared/models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends GenericService<any> {

  private currentUserSubject: BehaviorSubject<Servidor>;
  public currentUser: Observable<Servidor>;

  constructor(http: HttpClient) {
    super('authenticate', http);
    this.currentUserSubject = new BehaviorSubject<Servidor>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): Servidor {
    return this.currentUserSubject.value;
  }

  login(form: LoginUsuario, loading?: Loading): Observable<any> {
    return this.getHttpClient().post(`${this.api}`, form, { headers: this.getHeadersPublico() })
      .pipe(
        map((response: any) => {
          const servidor = form;

          localStorage.setItem('currentUser', JSON.stringify({ ...servidor, ...response }));
          this.currentUserSubject.next({ ...servidor, ...response });

          return { ...servidor, ...response };
        }),
        this.configMapAndLoading(loading));
  }

  logout(): any {
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('tokenFirebase');

    this.currentUserSubject = new BehaviorSubject<Servidor>({
      cpf: null,
      nome: null,
      dataNascimento: null,
      nomeMae: null,
      etapaAtendimento: null,
      idAutoAtendimento: null,
      siafi: null,
      token: null,
    });
  }

  result(): any {
    return pipe(
      map((res: any) => res),
      catchError((err: any) => throwError({ message: err })));
  }
}
